import { render, staticRenderFns } from "./LensItem.vue?vue&type=template&id=123483a2&scoped=true&"
import script from "./LensItem.vue?vue&type=script&lang=js&"
export * from "./LensItem.vue?vue&type=script&lang=js&"
import style0 from "./LensItem.vue?vue&type=style&index=0&id=123483a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123483a2",
  null
  
)

export default component.exports